import { RateVisitCard } from "@/components/shared/visits/rate-visit-card";
import { useVisitDetailStore } from "@/store/visits/visitDetail";
import { useVisitByClientWithTokenQuery } from "@/gqlhooks/visit/useVisitByClientWithTokenQuery";
import { VisitRateModalContainer } from "../visit-rate";
import { Message } from "@/components/shared/message";
import { Skeleton, View } from "@/components/ui";
import { MapPinArea } from "@/components/shared/icons";
import { VisitCard } from "@/components/shared/visits/visit-card";
import { ListHeading } from "@/components/shared/list-header";
import {
  useVisitIssueStore,
  VisitIssueType,
} from "@/store/report-issue/visit-issue/visitIssue";

export function VisitWithToken({
  token,
  type,
}: {
  token: string;
  type: "rate" | "reschedule";
}) {
  const {
    data: visit,
    loading,
    error,
  } = useVisitByClientWithTokenQuery(
    token ? { variables: { token } } : { skip: true },
  );

  const {
    openRateVisitModalById,
    openVisitModal,
    openRescheduleVisitConfirmation,
    data: { showRateVisitModal },
  } = useVisitDetailStore();

  const openVisitIssueModal = useVisitIssueStore(
    (state) => state.openVisitIssueModal,
  );

  const handleSetSchedule = () => {
    if (visit) {
      openRescheduleVisitConfirmation(visit.id, token);
    }
  };
  const handleReportVisit = () => {
    if (visit) {
      openVisitIssueModal(VisitIssueType.reportVisit, visit.id, false);
    }
  };
  const handleRateVisit = (visitId: string, rate?: number) => {
    openRateVisitModalById(visitId, rate);
  };

  if (loading) {
    return <Skeleton className="h-[200px] w-full" />;
  }

  if (error) {
    return <Message variant="danger" message={error.message} />;
  }

  if (!visit) {
    return null;
  }

  if (type === "reschedule") {
    return (
      <View className="flex flex-col gap-4">
        <ListHeading
          icon={MapPinArea}
          title="Your Upcoming Visits"
          subtitle="Manage your upcoming visit with ease. Click to make changes hassle-free."
        />

        <VisitCard
          visitData={visit}
          handleReportVisit={handleReportVisit}
          handleViewDetail={(visitId) => openVisitModal(visitId, token)}
          handleSetSchedule={handleSetSchedule}
          handleRateVisit={handleRateVisit}
        />
        {showRateVisitModal && <VisitRateModalContainer token={token} />}
      </View>
    );
  }

  return (
    <>
      <RateVisitCard visitData={visit} handleRateVisit={handleRateVisit} />
      {showRateVisitModal && <VisitRateModalContainer token={token} />}
    </>
  );
}
